import React, { useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { portalApiUrl } from './portalApi';
import '../crm/crm.css';

const PortalResetPin = () => {
    const history = useHistory();
    const location = useLocation();
    const token = useMemo(() => new URLSearchParams(location.search).get('token'), [location.search]);
    const [pin, setPin] = useState('');
    const [confirmPin, setConfirmPin] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (!token) {
            setError('Missing reset token');
            return;
        }
        if (!pin || pin !== confirmPin) {
            setError('PINs do not match');
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(portalApiUrl('/api/crm-portal/portal/reset-pin/confirm'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, newPin: pin }),
            });
            const data = await response.json().catch(() => ({}));
            if (!response.ok) {
                throw new Error(data.error || data.message || 'Reset failed');
            }
            history.push('/crm-portal/login');
        } catch (err) {
            setError(err.message || 'Reset failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--crm-bg-secondary)', padding: '24px' }}>
            <div className="crm-card" style={{ width: '100%', maxWidth: '420px' }}>
                <div className="crm-card-header">
                    <h2 className="crm-card-title">Reset PIN</h2>
                </div>
                <div className="crm-card-body">
                    {error && (
                        <div style={{ marginBottom: '16px', color: 'var(--crm-danger)' }}>
                            {error}
                        </div>
                    )}
                    <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '16px' }}>
                        <div>
                            <label className="crm-label">New PIN</label>
                            <input
                                className="crm-input"
                                type="password"
                                value={pin}
                                onChange={(e) => setPin(e.target.value)}
                                required
                            />
                        </div>
                        <div>
                            <label className="crm-label">Confirm PIN</label>
                            <input
                                className="crm-input"
                                type="password"
                                value={confirmPin}
                                onChange={(e) => setConfirmPin(e.target.value)}
                                required
                            />
                        </div>
                        <button className="crm-btn crm-btn-primary" type="submit" disabled={loading}>
                            {loading ? 'Resetting...' : 'Reset PIN'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PortalResetPin;
